import React, { ReactNode } from 'react';
import SearchList from './SearchList';

import { tabResultState } from '../../../modules/tabResult';
import { GetSearchParamType } from '../../../lib/tabResult/type';
import { PostConsumptionBodyType } from '../../../lib/common/type';

interface ViewMoreProps {
  isContents: boolean;

  loading: boolean;
  travel_info?: tabResultState['travel_info'];
  recommended_info?: tabResultState['recommended_info'];
  course_info?: tabResultState['course_info'];
  attachResult?: tabResultState['attachResult'];
  targetId: number;

  onPostConsumption: (info: PostConsumptionBodyType) => void;
  onGetSearch: (info: GetSearchParamType) => void;
  onSetIsMoreInfoResult: (
    isMoreInfoResult: tabResultState['isMoreInfoResult']
  ) => void;
}

const ViewMore = ({
  isContents,
  travel_info,
  recommended_info,
  course_info,
  attachResult,
  loading,
  targetId,
  onGetSearch,
  onSetIsMoreInfoResult,
  onPostConsumption,
}: ViewMoreProps) => {
  const makeList = (): ReactNode[] | null => {
    const resultReactNode: ReactNode[] | null = [];
    if (isContents) {
      switch (targetId) {
        case 0:
          resultReactNode.push(
            <SearchList
              travel_info={travel_info}
              onGetSearch={onGetSearch}
              onSetIsMoreInfoResult={onSetIsMoreInfoResult}
              onPostConsumption={onPostConsumption}
              loading={loading}
            />
          );
          break;
        case 1:
          resultReactNode.push(
            <SearchList
              recommended_info={recommended_info}
              onGetSearch={onGetSearch}
              onSetIsMoreInfoResult={onSetIsMoreInfoResult}
              onPostConsumption={onPostConsumption}
              loading={loading}
            />
          );
          break;
        case 2:
          resultReactNode.push(
            <SearchList
              course_info={course_info}
              onGetSearch={onGetSearch}
              onSetIsMoreInfoResult={onSetIsMoreInfoResult}
              onPostConsumption={onPostConsumption}
              loading={loading}
            />
          );
          break;
        case 3:
          resultReactNode.push(
            <SearchList
              attachResult={attachResult}
              onGetSearch={onGetSearch}
              onSetIsMoreInfoResult={onSetIsMoreInfoResult}
              onPostConsumption={onPostConsumption}
              loading={loading}
            />
          );
          break;
        default:
          break;
      }
    }
    return resultReactNode;
  };
  return <div>{makeList()}</div>;
};

export default ViewMore;
